import React from "react";

// Define a type for the props
type HighlightedTextProps = {
    text: string;
    indices?: [number, number][];
    current?: number;
    startAt?: number;
    originalText?: string;
};

const HighlightedText: React.FC<HighlightedTextProps> = ({
    text,
    indices,
    current = 0,
    startAt = 0,
}) => {
    // Base case: if there are no more indices to process, return the text
    if (
        !Array.isArray(indices) ||
        indices.length === 0 ||
        current >= indices.length
    ) {
        return <>{text}</>;
    }

    const [startIndex, endIndex] = indices[current]!;
    const relStartIndex = startIndex - startAt;
    const relEndIndex = endIndex - startAt;
    const before = text.substring(0, relStartIndex);
    const highlight = text.substring(relStartIndex, relEndIndex + 1);
    const after = text.substring(relEndIndex + 1);
    return relStartIndex < 0 ? (
        <HighlightedText
            text={text}
            indices={indices}
            current={current + 1}
            startAt={startAt}
        />
    ) : (
        <>
            {before}
            <span key={current} className="text-core-blue">
                {highlight}
            </span>
            {/* Recursively process the rest of the text and indices */}
            <HighlightedText
                text={after}
                indices={indices}
                current={current + 1}
                startAt={startAt + before.length + highlight.length}
            />
        </>
    );
};

export default HighlightedText;
